<template>
  <div class="h-full">
    <div class="md-layout bg-[#fff] h-full py-4">
      <div class="md-layout-item md-size-100">
        <isis-autocomplete
          v-model="userDirect.displayValue"
          :value.sync="userDirect.value"
          :options="userListOpts"
          :refetchOptions="
            queryObj =>
              userDirect.refetchOptions(userDirect.displayValue, queryObj)
          "
          :fields="userDirect.fields"
          :label="userDirect.label"
          fetchOnOpen
        />
      </div>

      <div class="parent" ref="listUserRefs">
        <ul class="child overflow-y-auto">
          <li
            v-for="(user, index) in listUser"
            :key="'list user' + index"
            class="cursor-pointer hover:bg-[#ebf5ef] min-h-[50px]"
            @click="setUserClicked(user)"
          >
            <div
              @click="getRoomChat(user)"
              :class="{ 'bg-[#ebf5ef]': user.room_id === currentId }"
              class="flex items-center w-full pl-2 my-1"
            >
              <img
                class=" w-[45px] h-[45px] rounded-2xl mr-4"
                :src="user.avatar || '/img/square_avt_default.jpg'"
              />
              <div>
                <p :class="{ 'font-medium': user.unread }">
                  {{ user.fullName }} - {{ user.username }}
                </p>
                <p
                  class="text-[12px]"
                  :class="user.unread ? 'font-medium' : 'text-[#aaa]'"
                >
                  {{ user.time }}
                </p>
              </div>
              <div class="flex text-right grow mr-6" v-if="user.unread">
                <span class="new-message text-center">{{ user.unread }}</span>
              </div>
            </div>
          </li>
          <li
            v-if="isShowLoading"
            class="flex justify-center cursor-pointer"
            @click="loadMoreUser"
          >
            {{ $t("setting.load_more") }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import { service_paths } from "../../../../../constants/Services";

export default {
  components: {},
  props: ["listUser", "roomId"],
  inject: ["routerToRoomChat", "searchUser"],
  data() {
    return {
      currentId: null,
      isConfirmDelete: false,
      isLoading: false,
      isShowLoading: false,
      limit: 10,
      userListOpts: [],
      userDirect: {
        label: "Search by full name, username, email, ID",
        value: "",
        displayValue: "",
        fields: {
          text: "displayName",
          value: "_id"
        },
        refetchOptions: (selectedValue, queryObj) => {
          return this.getUserOpts(selectedValue, queryObj);
        }
      }
    };
  },
  watch: {
    "userDirect.value": function(newVal) {
      if (!newVal) return;
      this.getChatDirectUser(newVal);
    }
  },
  methods: {
    loadMoreUser() {
      this.$emit("loadMoreUser");
    },
    getRoomChat(user) {
      if (!user) return;
      this.routerToRoomChat(user);
      this.$axios.post(
        `${service_paths.chat}/reset-number-unread-messages/room/${user.room_id}`,
        { user_id: user.user_id }
      );
    },
    setUserClicked(user) {
      this.currentId = user.room_id;
      setTimeout(() => (user.unread = 0), 2000);
    },
    async getChatDirectUser(userId) {
      let data = await this.$axios.post(
        `${service_paths.chat}/direct/users/${userId}`
      );
      const roomId = data.data.room_id;
      await this.searchUser(undefined, undefined, undefined, true);
      this.currentId = roomId;
      this.getRoomChat(this.listUser.find(item => item.room_id === roomId));
      this.userDirect.displayValue = "";
    },
    getUserOpts(value) {
      return this.$axios
        .get(
          service_paths.chat + "/direct/users",
          {
            limit: 10,
            search_key: value,
            fields: [
              "full_name",
              "student_code",
              "username",
              "staff_code",
              "email"
            ]
          },
          undefined,
          undefined,
          undefined,
          undefined,
          false
        )
        .then(({ data }) => {
          this.userListOpts = data.data.map(item => {
            return {
              ...item,
              displayName: `${item.full_name} - ${item.username}`
            };
          });
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.grow {
  flex-grow: 1;
}

.border-white {
  border: 2px solid #fff;
}

.border-green {
  border: 2px solid #5dcc7f;
}

.new-message {
  @apply rounded-full bg-[#f44336] text-[11px] leading-[24px] right-[-11px] top-[-14px] w-6 h-6 text-[#ffffff] font-medium;
}

.avatar {
  @apply object-cover rounded-2xl w-[45px] h-[45px] text-[#fff] font-medium items-center;
}

.parent {
  width: 100%;
  height: 100%;
  overflow: auto;

  .child {
    width: 100%;
    height: calc(100% - 77px);
    overflow-y: scroll;
    padding-right: 17px; /* Increase/decrease this value for cross-browser compatibility */
    box-sizing: content-box; /* So the width will be 100% + 17px */
  }
}

::-webkit-scrollbar {
  appearance: none;
  width: 7px;
  height: 7px;
}

::-webkit-scrollbar-thumb {
  background: #dadada;
  border-radius: 25px;
}
</style>
